// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YjFIi","right":"styles_right__-MdjU"};